import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { SalePriceSchedule } from '../models/sale-price-schedule';
import { SalePriceScheduleService } from './sale-price-schedule.service';
import { SalePriceScheduleType } from '../models/sale-price-schedule-type';


@Injectable()
export class SalePriceScheduleInMemoryService implements SalePriceScheduleService {

  getAllSalePriceSchedule(): Observable<SalePriceSchedule[]> {
    return of();
  }

  getAllScheduleTypes(): Observable<SalePriceScheduleType[]> {
    return of();
  }
}
